var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTemplates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6022 52.8477H63.7386C62.3321 52.8477 60.9833 53.4064 59.9888 54.4009C58.9943 55.3954 58.4355 56.7442 58.4355 58.1507V100.575C58.4355 101.981 58.9943 103.33 59.9888 104.325C60.9833 105.319 62.3321 105.878 63.7386 105.878H95.5568C96.9632 105.878 98.3121 105.319 99.3066 104.325C100.301 103.33 100.86 101.981 100.86 100.575V66.1052L87.6022 52.8477Z",
    fill: "#CAF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.178 45.4238H56.3144C54.9079 45.4238 53.5591 45.9825 52.5646 46.977C51.5701 47.9716 51.0114 49.3204 51.0114 50.7269V93.1511C51.0114 94.5576 51.5701 95.9064 52.5646 96.9009C53.5591 97.8954 54.9079 98.4541 56.3144 98.4541H88.1326C89.539 98.4541 90.8879 97.8954 91.8824 96.9009C92.8769 95.9064 93.4356 94.5576 93.4356 93.1511V58.6814L80.178 45.4238Z",
    fill: "#CAF0F8",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5265 45.4238V56.0299C77.5265 57.4363 78.0852 58.7852 79.0797 59.7797C80.0742 60.7742 81.4231 61.3329 82.8295 61.3329H93.4356",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85C80 83.1435 79.1571 81.363 77.6569 80.0503C76.1566 78.7375 74.1217 78 72 78C69.8783 78 67.8434 78.7375 66.3431 80.0503C64.8429 81.363 64 83.1435 64 85",
    stroke: "#0096C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 78C75.5376 78 78 75.5376 78 72.5C78 69.4624 75.5376 67 72.5 67C69.4624 67 67 69.4624 67 72.5C67 75.5376 69.4624 78 72.5 78Z",
    stroke: "#0096C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0336 49.7689V60.0676L70.2081 38.3477L42.0336 49.7689Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0337 49.7737L70.8544 38L31.5 42.079L42.0337 49.7737Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4204 51.9078L58.9888 61.9455L70.8539 38L45.4204 51.9078Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4208 51.9043L42.0336 60.0689L49.2518 54.7368L45.4208 51.9043Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0729 59.6354C42.2752 59.5506 42.471 59.4592 42.6668 59.3613L42.0729 59.6354Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0729 59.6354C42.2752 59.5506 42.471 59.4592 42.6668 59.3613",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTemplates);
export default __webpack_public_path__ + "static/media/Empty_templates.f84449ed7c72a18ce8acc37de3ec189c.svg";
export { ForwardRef as ReactComponent };